/**
 * @description Subscriber package string delimiter from Smart Tag paramsVO.USER.userStatus pattern key|value
 */
export enum SubscriberPackageDelimiter {
	V_PIPE = '|',
	EMPTY = ''
}